import { InfoCard } from "@backstage/core-components";
import { EntityLayout, EntityLinksCard } from "@backstage/plugin-catalog";
import {
  EntityGroupProfileCard,
  EntityOwnershipCard,
} from "@backstage/plugin-org";
import { Grid } from "@material-ui/core";
import { EntityCloudAssignmentsContent } from "@prisamedia/plugin-cloudhealth-explorer";

import { GroupMembersCard } from "../cards/GroupMembersCard";
import entityWarningContent from "../common/entityWarningContent";

export default (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}>
          <EntityGroupProfileCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard />
        </Grid>
        <Grid item xs={12}>
          <InfoCard title="Members" variant="gridItem">
            <GroupMembersCard />
          </InfoCard>
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityLinksCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/cloud-assets" title="Cloud Assets">
      <EntityCloudAssignmentsContent />
    </EntityLayout.Route>
  </EntityLayout>
);
